import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CursoService } from '../services/curso-service.service';
import { SpinnerService } from '../services/spinner.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-exito',
  templateUrl: './exito.component.html',
  styleUrls: ['./exito.component.css']
})
export class ExitoComponent implements OnInit {
  token: string | null = null;
  idPago: string = '';
  numeroOrden: string = '';
  tipoPago: string = '';
  fechaRegistroPago: string = '';
  aplicacion: string = '';
  totalPagar: string = '';
  nombrePaciente: string = '';
  responseCode: number | null = null;

  constructor(
    private route: ActivatedRoute,
    private cursoService: CursoService,
    private spinnerService: SpinnerService,
    private titleService: Title,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle('Cursos - MEDS');
    this.route.paramMap.subscribe(params => {
      this.token = params.get('token');
      // console.log('Token capturado:', this.token);
      if (this.token) {
        this.spinnerService.show();
        this.obtenerEstadoTransaccion(this.token);
      } else {
        console.error('Token no encontrado en la URL.');
        this.router.navigate(['/error']);
      }
    });
  }

  obtenerEstadoTransaccion(token: string): void {
    this.cursoService.getResponseTransaccion(token).subscribe({
      next: (response: any) => {
        // console.log('Respuesta del backend:', response);
        if (response && response.data) {
          const data = response.data;
          this.responseCode = data.response_code;
          if (this.responseCode !== 0) {
            console.error('El responseCode indica un error:', this.responseCode);
            this.spinnerService.hide();
            this.router.navigate(['/error']);
            return;
          }
          this.idPago = data.idPago;
          this.numeroOrden = data.numeroOrden;
          this.tipoPago = this.traducirTipoPago('CARD', data.tipoPago);
          this.fechaRegistroPago = this.formatDate(data.fechaRegistroPago);
          this.totalPagar = this.formatearMoneda(data.totalPagar);
          this.nombrePaciente = data.nombrePaciente;
          this.aplicacion = data.aplicacion;
        } else {
          console.error('La respuesta del backend no contiene datos.');
          this.router.navigate(['/error']);
        }
        this.spinnerService.hide();
      },
      error: (error) => {
        console.error('Error al consultar el estado de la transacción:', error);
        this.spinnerService.hide();
        this.router.navigate(['/error']);
      }
    });
  }

  redirectToMeds(): void {
    window.location.href = 'https://meds.cl';
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  formatearMoneda(valor: number | string): string {
    let num: number;
    if (typeof valor === 'string') {
      num = parseFloat(valor.replace(/[^0-9.]/g, ''));
    } else {
      num = valor;
    }
    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      minimumFractionDigits: 0
    }).format(num).replace(/\s*CLP/, '');
  }
  
  traducirTipoPago(tipoPago: string, paymentTypeCode?: string): string {
    if (tipoPago === 'CARD') {
      switch (paymentTypeCode) {
        case 'VD': return 'Tarjeta de Débito';
        case 'VN': return 'Tarjeta de Crédito';
        case 'VC': return 'Tarjeta de Crédito';
        case 'SI': return '3 Cuotas sin Interés';
        case 'S2': return '2 Cuotas sin Interés';
        case 'NC': return 'N Cuotas sin Interés';
        case 'VP': return 'Tarjeta de Prepago';
        default:   return 'Tarjeta';
      }
    } else {
      switch (tipoPago) {
        case 'TRANSFER': return 'Transferencia';
        case 'PAC': return 'Suscripción';
        case 'PAT': return 'Suscripción';
        default:        return tipoPago;
      }
    }
  }
}
